import { HttpClient, HttpParams } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { environment } from '@environments/environment'
import { map, Observable } from 'rxjs'
import { BlacklistListResponse, BlacklistListResult, CreateBlacklistPayload, CreateBlacklistResponse } from '../models/blacklist.model'

export type BlacklistListParams = {
  search: string
  page: number
  per_page: number
}

@Injectable()
export class BlacklistService {
  private readonly _http = inject(HttpClient)

  list(params: BlacklistListParams): Observable<BlacklistListResult> {
    const httpParams = new HttpParams().set('search', params.search).set('page', params.page).set('per_page', params.per_page)

    return this._http.get<BlacklistListResponse>(`${environment.planningApi}admin/blacklist`, { params: httpParams }).pipe(
      map((response) => ({
        items: response.data.items,
        pagination: response.data.pagination
      }))
    )
  }

  add(payload: CreateBlacklistPayload): Observable<CreateBlacklistResponse> {
    return this._http.post<CreateBlacklistResponse>(`${environment.planningApi}admin/blacklist`, payload)
  }
}
